var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.900097 9.1258L9.3001 0.700797C9.4001 0.600797 9.50843 0.529797 9.6251 0.487797C9.74176 0.445797 9.86676 0.42513 10.0001 0.425797C10.1334 0.425797 10.2584 0.446797 10.3751 0.488797C10.4918 0.530797 10.6001 0.601464 10.7001 0.700797L19.1251 9.1258C19.3584 9.35913 19.4751 9.6508 19.4751 10.0008C19.4751 10.3508 19.3501 10.6508 19.1001 10.9008C18.8501 11.1508 18.5584 11.2758 18.2251 11.2758C17.8918 11.2758 17.6001 11.1508 17.3501 10.9008L10.0001 3.5508L2.6501 10.9008C2.41676 11.1341 2.1291 11.2508 1.7871 11.2508C1.4451 11.2508 1.14943 11.1258 0.900097 10.8758C0.650097 10.6258 0.525097 10.3341 0.525097 10.0008C0.525097 9.66746 0.650097 9.3758 0.900097 9.1258Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.67137fd198eb82f95b53a705465d7512.svg";
export { ForwardRef as ReactComponent };